import { render, staticRenderFns } from "./AptitudeExamResults.vue?vue&type=template&id=358bd2a4&"
import script from "./AptitudeExamResults.vue?vue&type=script&lang=js&"
export * from "./AptitudeExamResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports